module.exports = __webpack_public_path__ + "media/images/flags/32/United-Nations-d2abc9b55ca3f5dbbe2c63d6f3cca0fa.png";